export const checkEmailContainer = "flex items-center justify-center min-h-screen bg-gray-200 dark:bg-gray-900 px-4";

export const checkEmailForm = "flex flex-col justify-center items-center w-full max-w-md p-9 bg-white rounded-lg shadow-lg dark:bg-gray-800";

export const iconContainer = "flex justify-center items-center mb-5";

export const mailIcon = "w-12 h-12 text-blue-500 bg-blue-100 p-2 rounded-full";

export const checkEmailTitle = "text-2xl font-semibold text-gray-800 dark:text-white text-center mb-2";

export const checkEmailText = "text-sm text-gray-500 dark:text-gray-400 text-center mb-6 leading-relaxed";

export const openEmailBtn = "w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 transition duration-200 mb-4";

export const infoText = "text-gray-500 dark:text-gray-400 text-sm text-center";

export const resendEmail = "text-blue-500 hover:text-blue-600 dark:text-blue-400 cursor-pointer";

export const backToLogin = "text-blue-500 hover:text-blue-600 dark:text-blue-400 text-sm text-center cursor-pointer";
